/**
 * Returns the current app environment: 'production' or 'qa'.
 * Determined at compile-time via VITE_APP_ENV.
 * Defaults to 'qa' if not set.
 */
export function getAppEnvironment(): 'production' | 'qa' {
  return import.meta.env.VITE_APP_ENV === 'production' ? 'production' : 'qa';
}
